/**
 * validateNewLead — Pure function fuer Frontend-Pflichtfeld-Validation
 * der manuellen Lead-Anlage (BOARD-07).
 *
 * Strenger als Backend-Validator: erzwingt zusaetzlich Ansprechpartner +
 * "Telefon ODER E-Mail" als getrennte Pro-Feld-Errors (damit das UI die
 * roten Inline-Hinweise an beiden Feldern setzen kann).
 *
 * Backend (backend/src/validators.ts.validateCreateLead) liefert dieselben
 * Regeln, gibt aber bei fehlender Phone+Mail nur EINEN Error mit
 * field='verein' zurueck. Das Frontend braucht die Aufspaltung fuer
 * field-spezifische Error-Anzeige.
 *
 * Wichtig: pure — kein Side-Effect, keine console-Calls, keine Date-Calls.
 */

export interface NewLeadForm {
  vereinName: string;
  vereinEmail: string;
  vereinPhone: string;
  vereinContactPerson: string;
  assignedUserId: number | null;
  tags: string[];
  notes: string;
}

export interface ValidationError {
  field: string;
  message: string;
}

// Einfacher RFC-light E-Mail-Regex (Frontend-only, Backend prueft strenger).
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateNewLead(form: NewLeadForm): ValidationError[] {
  const errors: ValidationError[] = [];

  // Pflichtfeld: Vereinsname (mit trim-Check gegen reine Leerzeichen).
  if (!form.vereinName || form.vereinName.trim().length === 0) {
    errors.push({ field: 'vereinName', message: 'Vereinsname ist Pflicht' });
  }

  // Pflichtfeld: Ansprechpartner.
  if (
    !form.vereinContactPerson ||
    form.vereinContactPerson.trim().length === 0
  ) {
    errors.push({
      field: 'vereinContactPerson',
      message: 'Ansprechpartner ist Pflicht',
    });
  }

  // Mindestens-Eines-Pflicht: Telefon ODER E-Mail.
  const hasPhone = !!form.vereinPhone && form.vereinPhone.trim().length > 0;
  const hasEmail = !!form.vereinEmail && form.vereinEmail.trim().length > 0;

  if (!hasPhone && !hasEmail) {
    errors.push({
      field: 'vereinPhone',
      message: 'Mindestens Telefon oder E-Mail angeben',
    });
    errors.push({
      field: 'vereinEmail',
      message: 'Mindestens Telefon oder E-Mail angeben',
    });
  }

  // Format-Check fuer E-Mail (nur wenn ausgefuellt).
  if (hasEmail && !EMAIL_RE.test(form.vereinEmail.trim())) {
    errors.push({
      field: 'vereinEmail',
      message: 'E-Mail-Format ungueltig',
    });
  }

  return errors;
}
